import BrickTitle from "@/components/landing/BrickTitle";

const items = [
  {
    url: "https://images.unsplash.com/photo-1608126842270-59250519e99f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwyfHx3ZWxkaW5nJTIwc3RlZWwlMjByYWlsaW5nJTIwY2xvc2UlMjB1cHxlbnwwfHx8fDE3OTA2MjAyNzd8MA&ixlib=rb-4.1.0&q=85",
    caption: "Structural Steel Railing Weld",
    alt: "Close-up of cleanly welded steel stair railing in home renovation",
  },
  {
    url: "https://images.unsplash.com/photo-1614204707763-a3d5af01c7a6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwyfHxjdXN0b20lMjBoYXJkd29vZCUyMGJyZWFrZmFzdCUyMGJhcnxlbnwwfHx8fDE3OTA2MjAyNzd8MA&ixlib=rb-4.1.0&q=85",
    caption: "Custom Oak Bar Top",
    alt: "Solid hardwood custom breakfast bar with satin polyurethane finish",
  },
  {
    url: "https://images.unsplash.com/photo-1660330589827-da8ab7dd3c02?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHwzfHxhYyUyMGNvbmRlbnNlciUyMGluc3BlY3Rpb258ZW58MHx8fHwxNzkwNjIwMjc3fDA&ixlib=rb-4.1.0&q=85",
    caption: "HVAC Condenser Overhaul",
    alt: "EPA certified AC condenser inspection with digital manifold gauges",
  },
  {
    url: "https://images.unsplash.com/photo-1685537711146-d6c29e41eeb6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwyfHxyb29mJTIwcmVwYWlyJTIwY2hpbW5leXxlbnwwfHx8fDE3OTA2MjAyNzd8MA&ixlib=rb-4.1.0&q=85",
    caption: "Flashing & Valley Leak Seal",
    alt: "Seamless roof leak repair around chimney with lead-free flashing",
  },
];

export default function Gallery() {
  return (
    <section className="py-16 bg-[#1B2229] border-y border-[#3A4752]" data-testid="gallery-section">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-10">
          <div>
            <span className="text-xs font-bold uppercase tracking-widest text-[#D4691E]">Craftsmanship In Focus</span>
            <h2 className="text-3xl font-bold mt-1"><BrickTitle text="Real Jobs, Clean Finishes" /></h2>
          </div>
          <p className="text-sm text-[#736B63] max-w-md mt-2 md:mt-0">
            Every project handled with meticulous workspace protection and precise finishing standards.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {items.map((it, i) => (
            <div
              key={it.caption}
              data-testid={`gallery-item-${i}`}
              className="group relative aspect-[4/3] rounded-lg overflow-hidden border border-[#DCD3C9]"
            >
              <img
                src={it.url}
                alt={it.alt}
                loading="lazy"
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent flex items-end p-4">
                <span className="text-xs font-semibold text-white">{it.caption}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
